import http from 'plugins/axios';

export default {
  getWhitelist() {
    return http.get({
      url: '/admin/siteconf/get',
      params: {
        key: 'WITHDRAW_APPROVAL_WHILELIST',
        page: 1,
        size: 1000
      }
    });
  },

  createWhitelist(value) {
    return http.post({
      url: '/admin/siteconf/create',
      dataType: 'form',
      data: {
        key: 'WITHDRAW_APPROVAL_WHILELIST',
        value: JSON.stringify(value)
      }
    });
  },

  updateWhitelist(value) {
    return http.post({
      url: '/admin/siteconf/update',
      dataType: 'form',
      data: {
        key: 'WITHDRAW_APPROVAL_WHILELIST',
        value: JSON.stringify(value)
      }
    });
  }
};
